import axios from "axios";
import { baseUrl } from "./baseUrl";
import {
    getAdminToken,
    removeAdminToken,
    removeUserInfo
} from "./localStorage";

const apiClient = axios.create({
    baseURL: baseUrl,
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});

// REQUEST INTERCEPTOR
apiClient.interceptors.request.use(
    (config) => {
        const token = getAdminToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                // FULL CLEAN LOGOUT
                removeAdminToken();
                removeUserInfo();

                if (window.location.pathname !== "/adminlogin") {
                    window.location.href = "/adminlogin";
                }
            }

            if (status === 403) {
                console.error("Forbidden access");
            }

            if (status === 500) {
                console.error("Server error");
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;